import * as actions from '../../../../redux/actions';
import {
  APPROVAL_ACTION_LABEL,
  REVIEW_ACTION_LABEL,
  APPROVAL_ACTOR_LABEL,
  REVIEW_ACTOR_LABEL,
  PAYMENT_APPROVAL_STATUS_META,
  EXPENSE_REVIEW_STATUS_META,
} from './status';

// 2 หน้าใช้ component/hook ชุดเดียวกันทั้งหมด (ExpenseQueuePage.js) ต่างกันแค่ config ในไฟล์นี้:
//  - /profile/payment-approval (PAYMENT_MODE) — flag หลักคือ payment_approval_status
//  - /profile/expense-review   (REVIEW_MODE)  — flag หลักคือ review_status
// "primary" = flag ที่หน้านั้นกดเปลี่ยนได้ (chip ใต้รหัส + สีพื้นแถว + ปุ่ม action + 2 คอลัมน์ท้าย)
// "secondary" = flag ของอีกหน้า โชว์เป็น chip อ่านอย่างเดียวในคอลัมน์สถานะ (คู่กับ Expenses.status)
// จะแก้ข้อความ/field ของหน้าไหน แก้ที่นี่ที่เดียว ไม่ต้องไล่แก้ใน component
export const PAYMENT_MODE = {
  // สิทธิ์เข้าหน้า — approver_settings key ที่ /management/approvers
  accessKey: 'payment',
  noAccessText: 'เฉพาะผู้ที่ถูกตั้งเป็นผู้อนุมัติการจ่ายเงินเท่านั้น',
  emptyText: 'ไม่มีรายการรออนุมัติ',

  statusField: 'payment_approval_status',
  statusMeta: PAYMENT_APPROVAL_STATUS_META,
  actorLabel: APPROVAL_ACTOR_LABEL,
  actorNameField: 'payment_approved_by_name',
  actorAtField: 'payment_approved_at',
  noteField: 'payment_approval_note',

  // ปุ่มบวก/ลบ (ปุ่ม "รอก่อน"/HOLD กับ "ยกเลิก"/RESET เหมือนกันทั้ง 2 หน้า)
  positiveAction: { code: 'APPROVE', label: 'อนุมัติ' },
  negativeAction: { code: 'REJECT', label: 'ปฏิเสธ' },
  actionLabel: APPROVAL_ACTION_LABEL,
  resetTooltip: 'ยกเลิกการตัดสินใจ กลับไปเป็นรอตัดสินใจ',
  resetCardLabel: 'ยกเลิกการตัดสินใจ',
  dialogSubject: 'การจ่ายเงิน',
  setStatusAction: actions.expensesSetPaymentApproval,

  headStatus: 'สถานะการอนุมัติ',
  headActor: 'อนุมัติโดย / เวลา',
  headNote: 'หมายเหตุการอนุมัติ',

  // query param ที่ backend ใช้กรอง flag หลัก + ค่าของแท็บ อนาคต/ประวัติ (ดู utils/query.js)
  queryParam: 'paymentApprovalStatuses',
  futureStatuses: 'PENDING,HOLD,APPROVED',
  historyStatuses: 'APPROVED,REJECTED',

  secondary: {
    statusField: 'review_status',
    statusMeta: EXPENSE_REVIEW_STATUS_META,
    approverKey: 'expense_reviewer',
    byNameField: 'reviewed_by_name',
    noteField: 'review_note',
    pendingLabel: 'รอตรวจสอบจาก',
  },
};

export const REVIEW_MODE = {
  accessKey: 'expense_reviewer',
  noAccessText: 'เฉพาะผู้ที่ถูกตั้งเป็นผู้ตรวจสอบรายการเบิกเงินเท่านั้น',
  emptyText: 'ไม่มีรายการรอตรวจสอบ',

  statusField: 'review_status',
  statusMeta: EXPENSE_REVIEW_STATUS_META,
  actorLabel: REVIEW_ACTOR_LABEL,
  actorNameField: 'reviewed_by_name',
  actorAtField: 'reviewed_at',
  noteField: 'review_note',

  positiveAction: { code: 'REVIEW', label: 'ตรวจสอบแล้ว' },
  negativeAction: { code: 'FLAG', label: 'พบปัญหา' },
  actionLabel: REVIEW_ACTION_LABEL,
  resetTooltip: 'ยกเลิกการตรวจสอบ กลับไปเป็นรอตรวจสอบ',
  resetCardLabel: 'ยกเลิกการตรวจสอบ',
  dialogSubject: 'รายการเบิกเงิน',
  setStatusAction: actions.expensesSetReviewStatus,

  headStatus: 'สถานะการตรวจสอบ',
  headActor: 'ตรวจสอบโดย / เวลา',
  headNote: 'หมายเหตุการตรวจสอบ',

  queryParam: 'reviewStatuses',
  futureStatuses: 'PENDING,HOLD,REVIEWED',
  historyStatuses: 'REVIEWED,FLAGGED',

  secondary: {
    statusField: 'payment_approval_status',
    statusMeta: PAYMENT_APPROVAL_STATUS_META,
    approverKey: 'payment',
    byNameField: 'payment_approved_by_name',
    noteField: 'payment_approval_note',
    pendingLabel: 'รออนุมัติจาก',
  },
};
